var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24196",
    "data-name": "Rectangle 24196",
    width: 84,
    height: 84,
    fill: "#fe6831"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users_02",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74634",
    "data-name": "Path 74634",
    d: "M114.412,0H97.394A22.106,22.106,0,0,0,75.313,22.081V38.137c.23-.261.467-.518.716-.766L94.356,19.043A2.444,2.444,0,0,1,97.813,22.5L79.485,40.827c-.231.231-.448.47-.656.716H94.775a22.106,22.106,0,0,0,22.081-22.081V2.444A2.444,2.444,0,0,0,114.412,0Z",
    transform: "translate(-33.73 0.463)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74635",
    "data-name": "Path 74635",
    d: "M14.3,2.444a2.444,2.444,0,0,0-4.889,0V10.82H14.3Z",
    transform: "translate(-4.486 0.463)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74636",
    "data-name": "Path 74636",
    d: "M42.545,2.444a2.444,2.444,0,0,0-4.889,0V10.82h4.889Z",
    transform: "translate(-17.019 0.463)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74637",
    "data-name": "Path 74637",
    d: "M82.271,95.12H64.539A11.369,11.369,0,0,1,53.464,81.213a7.336,7.336,0,0,1-4.353-2.566,16.257,16.257,0,0,0,15.428,21.362H82.271a6.719,6.719,0,1,1,0,13.439h-43.2A10.641,10.641,0,0,1,28.424,102.8V81.186a20.418,20.418,0,0,1-4.889,0V102.8a15.527,15.527,0,0,0,15.535,15.535h43.2a11.608,11.608,0,1,0,0-23.216Z",
    transform: "translate(-10.753 -34.438)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74638",
    "data-name": "Path 74638",
    d: "M31.071,38.541V30.687a2.444,2.444,0,0,0-2.444-2.444H2.444A2.444,2.444,0,0,0,0,30.687v7.855a15.535,15.535,0,0,0,31.071,0Z",
    transform: "translate(-0.309 -12.07)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.0e880b8ddea4a2fb4d0aa18367cd1017.svg";
export { ForwardRef as ReactComponent };